// 法律声明
<template>
  <div class="legalNotice">
    <div class="title">法律声明</div>
    <div class="content">
      <div class="content-title">版权</div>
      <div class="content-text">
        本网站包含之所有内容：文本、图形、LOGO、创意、及软件等之所有权归属”华院计算技术（上海）股份有限公司”及本网站的内容/信息提供者，受中国及国际版权法的保护。对本网站上所有内容之复制（意指收集、组合和重新组合），本网站享有排他权并受中国及国际版权法的保护。本网站使用的所有软件的所有权归属于”华院计算技术（上海）股份有限公司”或它的软件供应商并受中国及国际版权法的保护。在本网站上的内容和软件可以用作信息获取资源，对本网站该等内容的任何其他使用，包括再造、修改、发布、转发、再版、演示或播出被严格禁止。
        鉴于对作者的尊重和对知识产权的保护，本网站对于发表在”华院计算技术（上海）股份有限公司”的未名作者以及尚未联系到作者的作品，特此声明：若该文作者愿意将作品发表在”华院计算技术（上海）股份有限公司”
        ，我们愿付以作者相应的稿酬；若该文作者不同意，我们将尊重其本人意见，删除该作品。
      </div>
      <div class="content-title">网站使用</div>
      <div class="content-text">
        “华院计算技术（上海）股份有限公司”及其任何组成部分不得被再造、复制、抄袭、交易，或为任何未经”华院计算技术（上海）股份有限公司”允许的商业目的所使用。如果”华院计算技术（上海）股份有限公司”确定客户行为违法或有损其利益，则”华院计算技术（上海）股份有限公司”将保留采取进一步措施的权利。
      </div>
      <div class="content-title">适用法律</div>
      <div class="content-text">
        “华院计算技术（上海）股份有限公司网站”
        （www.unidt.com）由华院运营和控制，适用中华人民共和国法律。我们保留随时更改我们的网站和上述免责及条款的权利。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'legalNotice',
  data() {
    return {}
  },
}
</script>
<style lang="less" scoped>
.legalNotice {
  width: 100%;
  padding: 96px 0px;
  .title {
    width: calc(100% - 64px);
    height: 174px;
    background: url('../../../static/img/other/legalnotice_bg.png') no-repeat 0 0 / 100%;
    overflow: hidden;
    font-size: 44px;
    color: #08204D;
    line-height: 174px;
    padding-left: 64px;
  }
  .content {
    padding: 40px 64px;
    .content-title {
      font-size: 32px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #08204D;
      line-height: 44px;
      margin-bottom: 24px;
    }
    .content-text {
      font-size: 24px;
      font-weight: 400;
      color: #08204D;
      line-height: 40px;
      margin-bottom: 64px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/otherFunction/legalNotice.vue